/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EvaluationInterface } from '../../+models';
import { AddEvaluationResponseInterface, DeleteEvaluationResponseInterface } from '../../evaluation';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EvaluationApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Evaluations');
  }

  find(params?): Observable<EvaluationInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<EvaluationInterface[]>(path, httpParams);
  }

  addEvaluationForToc(tocId: number, evaluation): Observable<AddEvaluationResponseInterface> {
    const path = `create-for-toc/${tocId}`;
    return this.put<AddEvaluationResponseInterface>(path, undefined, evaluation);
  }

  patchAttributes(evaluationId: number, changes): Observable<EvaluationInterface> {
    const path = `${evaluationId}`;
    return this.patch<EvaluationInterface>(path, undefined, changes);
  }

  deleteEvaluationForToc(tocId: number, evaluationId: number): Observable<DeleteEvaluationResponseInterface> {
    const path = `${evaluationId}/delete-for-toc/${tocId}`;
    return this.delete<DeleteEvaluationResponseInterface>(path, undefined);
  }
}
